<template>
  <div>
    <div class="relative">
      <SecondayButtonDropdown
        :class="override === null ? 'text-gray-700 hover:text-gray-500 ' : 'bg-gray-800 text-white'"
        text="Modify Times"
        :disabled="disabled"
        @click="open = !open"
      />

      <div class="absolute top-0 left-0 pt-10">
        <div
          v-if="open"
          class="bg-white border shadow rounded-lg overflow-hidden p-4 w-72"
        >
          <div class="text-sm text-gray-600 font-medium mb-2">
            Start Time <span v-if="override !== null">(Currently {{ new Date(override.startTime) | moment("HH:mm") }})</span>
          </div>
          <input
            v-model="startTime"
            type="time"
            class="form-input transition duration-150 ease-in-out sm:text-sm sm:leading-5 inline-block w-full min-w-full text-center h-full outline-none focus:outline-none"
            style="border-width: 0; border-radius: 0; padding: 0; padding-left: 0.75rem; padding-right: 0.5rem;"
          >

          <div class="h-1 mt-3 mb-3 w-full border-b" />

          <div class="text-sm text-gray-600 font-medium mb-2">
            End Time <span v-if="override !== null">(Currently {{ new Date(override.endTime) | moment("HH:mm") }})</span>
          </div>
          <input
            v-model="endTime"
            type="time"
            class="form-input transition duration-150 ease-in-out sm:text-sm sm:leading-5 inline-block w-full min-w-full text-center h-full"
            style="border-width: 0; border-radius: 0; padding: 0; padding-left: 0.75rem; padding-right: 0.5rem;"
          >

          <PrimaryButton
            class="mt-6"
            text="Apply"
            :disabled="!isValid"
            :loading="loading"
            @click="submit"
          />

          <SecondaryButton
            class="mt-2 w-full"
            text="Close"
            @click="open = false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SecondayButtonDropdown from '@/app/shared/components/base/button/secondaryButtonDropdown.vue';
import PrimaryButton from '@/app/shared/components/base/button/primaryButton.vue';
import SecondaryButton from '@/app/shared/components/base/button/secondaryButton.vue';
import { OverrideTeeConfigurationDay, GetConfigurationDayOverride } from '@/app/shared/services/teeConfigService/teeConfigService.js';


export default {
  components: {
    PrimaryButton,
    SecondaryButton,
    SecondayButtonDropdown,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    teeConfigId: {
      type: String,
      default: null,
    },
    selectedDate: {
      type: Date,
      default: null,
    },
    noSlots: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      open: false,
      loading: false,
      startTime: null,
      endTime: null,

      override: null,
    };
  },

  computed: {
    isValid() {
      return this.startTime !== null && this.endTime !== null;
    },
  },

  watch: {
    noSlots() {
      if (!this.noSlots) {
        this.getOverride();
      } else {
        this.override = null;
      }
    },
  },

  methods: {
    async submit() {
      if (this.isValid && !this.loading) {
        this.loading = true;
        await OverrideTeeConfigurationDay(this.teeConfigId, this.selectedDate, this.startTime, this.endTime);
        this.loading = false;
        this.open = false;
        this.startTime = null;
        this.endTime = null;
        this.$emit('complete');
        this.getOverride();
      }
    },

    getOverride() {
      const date = this.selectedDate;
      GetConfigurationDayOverride(this.teeConfigId, date).then((data) => {
        if (this.selectedDate === date) {
          this.override = data;
        }
      });
    },
  },
};
</script>
